import script from "./ChatMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessage.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessage.vue?vue&type=style&index=0&id=2f905603&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f905603"]])

export default __exports__